import React from 'react'

function Web() {
    return (
        <>
            <head>
                <title>مواقع إلكترونية احترافية تزيد من حضورك الرقمي</title>
                <meta name="description" content="نصمم في بروتك المتحدة مواقع ويب متكاملة وسريعة، مع ضمان توافقها مع جميع الأجهزة ومحركات البحث لتعزيز وصولك للعملاء المستهدفين." />
            </head>
            <div>
                    <h1> بتحتاج موقع يقدم خدماتك أو يعرض منتجاتك؟</h1>
                <ol>
                    <li>نعمل مواقع نظيفة وسريعة تنفتح على كل الأجهزة.</li>
                    <li>الموقع راح يكون سهل التصفح وواضح للزائر.</li>
                    <li> نضبطه عشان يظهر أول ما أحد يبحث عن خدماتك.</li>
                    <li>تقدر تتحكم في المحتوى بنفسك بعد التسليم.</li>
                </ol>
            </div>
        </>
    )
}

export default Web